module.exports = __webpack_public_path__ + "static/ML_hero-technology-b2d0aa20d5a268d8dab25015f0095ae3.jpg";